import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getDomainForCookie, validateCookieValue, validateInput } from './helpers';
import { cookieKeys, regexes } from './constants';
import { readCookie, writeCookie } from './read-write-cookies';
var COUNTRY_COOKIE_KEY = cookieKeys.COUNTRY_COOKIE_KEY,
    LANGUAGE_COOKIE_KEY = cookieKeys.LANGUAGE_COOKIE_KEY,
    COMBINED_COOKIE_KEY = cookieKeys.COMBINED_COOKIE_KEY,
    CHOICE_COOKIE_KEY = cookieKeys.CHOICE_COOKIE_KEY,
    CHOSEN_COOKIE_KEY = cookieKeys.CHOSEN_COOKIE_KEY; // "legacy format" – in reference to language tags – is used to mean
// an ISO 639-1 language and an ISO 3166-1 alpha-2 country, separated by an underscore

var countryRegex = regexes.countryRegex,
    legacyLanguageRegex = regexes.legacyLanguageRegex,
    combinedRegex = regexes.combinedRegex;
var defaultConfig = {
  expires: 365 // one year

};
/**
 * @returns {string|undefined} - string: country tag (in ISO 3166-1 alpha-2 format)
 */

export function getMarketplace() {
  var cookieValue = readCookie(COUNTRY_COOKIE_KEY);
  return validateCookieValue(cookieValue, countryRegex, 'marketplace');
}
/**
 * @returns {string|undefined} - string: language tag (in legacy format)
 */

export function getLanguage() {
  var cookieValue = readCookie(LANGUAGE_COOKIE_KEY);
  return validateCookieValue(cookieValue, legacyLanguageRegex, 'language');
}
/**
 * @returns {object} - consumer choice settings
 * (e.g. { choice: 'gb/en_gb', chosen: true })
 */

export function getConsumerChoice() {
  var choiceCookieValue = readCookie(CHOICE_COOKIE_KEY);
  var chosenCookieValue = readCookie(CHOSEN_COOKIE_KEY);
  var validatedChosen = validateCookieValue(chosenCookieValue, /^t$/, 'consumer chose');
  return {
    // We are seeing experiences submit choiceCookie value incorrectly with GB/en_gb and the casing
    // is causing it not to be found and erring out.  Adding toLowerCase() to protect and get 'gb/en_gb'
    // to align with regex.
    choice: validateCookieValue(choiceCookieValue ? choiceCookieValue.toLowerCase() : undefined, combinedRegex, 'consumer choice'),
    // validatedChosen is either undefined or 't'
    // return either undefined or true, because 't' doesn't seem super meaningful
    chosen: validatedChosen ? !!validatedChosen : validatedChosen
  };
}
/**
 * @param {string} marketplace - currently requires a country in ISO 3166-1 alpha-2 format
 * @param {string} language - currently requires a language in legacy format
 * @param {boolean} chosen - if true, sets consumer choice (which is never unset)
 * @returns {boolean} - indication of successfully set locale
 */

export function setLocale(marketplace, language, chosen) {
  var validatedMarketplace = validateInput(marketplace, countryRegex, 'marketplace');
  var validatedLanguage = validateInput(language, legacyLanguageRegex, 'language');

  var cookieConfig = _objectSpread(_objectSpread({}, defaultConfig), {}, {
    domain: getDomainForCookie(window.location.hostname)
  });

  var formattedLocale = "".concat(validatedMarketplace, "/").concat(validatedLanguage).toLowerCase();
  writeCookie(COUNTRY_COOKIE_KEY, validatedMarketplace, cookieConfig);
  writeCookie(LANGUAGE_COOKIE_KEY, validatedLanguage, cookieConfig);
  writeCookie(COMBINED_COOKIE_KEY, formattedLocale, _objectSpread(_objectSpread({}, cookieConfig), {}, {
    expires: ''
  }));

  if (chosen === true) {
    writeCookie(CHOICE_COOKIE_KEY, formattedLocale, cookieConfig);
    writeCookie(CHOSEN_COOKIE_KEY, 't', cookieConfig);
  }

  return true;
}